import React from 'react'
import styled from 'styled-components'
import {Spacer} from 'layout/util'
import {Link} from 'react-router-dom'
import Color from 'constants/colors'
import {NavArrow} from 'components/static/icons'

const BlockWrapper = styled.div`
  @media print {
    display: none;
  }
`;

const Container = styled.div`
	width: 100%;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	box-sizing: border-box;
	background-color: ${props=>Color(props.color)};
  @media screen and (max-width: 767px) {
  	flex-direction: column;
  	align-items: center;
  }
`;

const TileInteraction = styled.div`
	padding-top: 20px;
	padding-bottom: ${props=>props.bottomOut?0:20}px;
	max-height: 200px;
	max-width: 380px;
	border-radius: 1px;
	cursor: pointer;
  @media not all and (hover: none) {
    &:hover {
      background-color: rgba(255,255,255,0.4);
      transition: background-color 150ms ease-out;
    }
  }
`;

const Tile = styled(Link)`
	display: flex;
	flex-direction: row;
	align-items: center;
	text-decoration: none;
	color: black;
`;

const Img = styled.img`
	width: ${props=>props.bottomOut?"":"40%"};
	object-fit: contain;
	max-height: 200px;
`;

const Text = styled.h3`
	padding: 0 10px;
	display: block;
	box-sizing: border-box;
	width: 70%;
	order: ${props=>props.evenOdd%2===0?1:0};
	text-align: ${props=>props.evenOdd%2===0?"left":"right"};
`;

const ArrowStyle = styled.div`
	width: 50px;
	order: ${props=>props.evenOdd%2===0?0:3};
	transform: ${props=>props.evenOdd%2===0?"rotate(180deg)":"none"};
`;

const BottomNav = (props) => {
	const nav = props.data.tiles.map( (tile, i) => {
		const {img, text, to} = tile;
		return (
			<TileInteraction bottomOut={props.bottomOut} key={i} >
				<Tile to={to}>
					<ArrowStyle evenOdd={i}><NavArrow color="#333"/></ArrowStyle>
					<Text evenOdd={i}>{text}</Text>
					<Img bottomOut={props.bottomOut} src={img} alt={`Navigate to ${text}`}/>
				</Tile>
			</TileInteraction>

		)
	})

	return(
		<BlockWrapper>
			<Spacer height={30}/>
			<Container color={props.color}>
				{nav}
			</Container>
		</BlockWrapper>
	);
}

export default BottomNav;


// WEBPACK FOOTER //
// ./src/pages/june-5/props/components/BottomNavBlock.js